<template>
  <div id="vehicles_ship">
    <div v-if="receivedData">
      <SelectGraphic 
        :receivedData="receivedData"
        id="vehicles"
      />
    </div>
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'AgeRoadMechanicalVehicle',
  components: {
    SelectGraphic: () => import('@/components/graph/SelectGraphic.vue'),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'age_vehicles',
      cloneElementId: 'vehicles_ship'
    }
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },
    
  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData () {
      this.getGraphData()
      Service.elementClone(this.blockId, this.cloneElementId)
    },

    getGraphData() {
      CMS.getGraph(this.userToken, '41,42,43,44,45,46,47,48,49').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>